import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Query } from '@apollo/client/react/components';

import { ErrorCard } from '@sm/webassets';
import { Typography } from '@wds/typography';
import { Box } from '@wds/box';
import { Button } from '@wds/button';

import appsAppListings from '../AppListingContext/AppListings.graphql';
import AppsGrid from '../AppsGrid/AppsGrid';
import CategorySectionSkeleton from './CategorySectionSkeleton';
import useStyles from './styles';

export const getCategoryFromKey = (categories, key) => {
  const results = categories.filter(cat => cat.key === key);
  return results[0] || {};
};

const CategorySection = ({ queryParams, sectionName, moreLink, moreLinkLabel, lessLink, lessLinkLabel }) => {
  const [showMore, setShowMore] = useState(false);
  const { textRight } = useStyles();
  return (
    <Query query={appsAppListings} variables={queryParams}>
      {({ loading, error, data }) => {
        return (
          <section>
            <Box display="flex" placeItems="center" flexJustify="space-between" mb={4}>
              <Typography variant="sectionTitle" weight="medium">
                {sectionName}
              </Typography>
              <If condition={moreLinkLabel && !showMore}>
                <Button
                  color="link"
                  variant="text"
                  onClick={() => {
                    moreLink();
                    setShowMore(true);
                  }}
                >
                  {moreLinkLabel}
                </Button>
              </If>
            </Box>
            <Choose>
              <When condition={error}>
                <ErrorCard />
              </When>
              <When condition={loading}>
                <CategorySectionSkeleton data-testid="CategorySection__Skeleton" />
              </When>
              <Otherwise>
                <>
                  <AppsGrid apps={data.fetchPublishedApplicationListings.data} />
                  <If condition={showMore}>
                    <Box className={textRight} mt={3}>
                      <Button
                        color="link"
                        variant="text"
                        onClick={() => {
                          lessLink();
                          setShowMore(false);
                        }}
                      >
                        {lessLinkLabel}
                      </Button>
                    </Box>
                  </If>
                </>
              </Otherwise>
            </Choose>
          </section>
        );
      }}
    </Query>
  );
};

CategorySection.propTypes = {
  queryParams: PropTypes.shape({
    categories: PropTypes.arrayOf(PropTypes.string),
    featured: PropTypes.bool,
    search: PropTypes.string,
    sortOrder: PropTypes.string,
    sortBy: PropTypes.string,
    page: PropTypes.number,
    pageSize: PropTypes.number,
  }),
  sectionName: PropTypes.string,
  moreLink: PropTypes.func,
  moreLinkLabel: PropTypes.string,
  lessLink: PropTypes.func,
  lessLinkLabel: PropTypes.string,
};

CategorySection.defaultProps = {
  queryParams: {
    featured: true,
  },
  sectionName: 'Featured',
  moreLink: () => {},
  moreLinkLabel: '',
  lessLink: () => {},
  lessLinkLabel: '',
};

export default CategorySection;
